module.exports = __webpack_public_path__ + "img/logo.2d95cca2.png";